<template>
  <div
    class="modal"
    tabindex="-1"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
          >
            Edit Machine
          </h5>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>

        <div class="modal-body">
          <machine-form
            :sections="sections"
            :entity="machine"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MachineForm } from '../../../forms';

export default {
  name: 'EditMachineModal',
  components: { MachineForm },
  props: {
    sections: {
      type: Array,
      default: () => []
    },
    machine: {
      type: Object,
      default: () => null
    }
  }
};
</script>
